module.exports = __webpack_public_path__ + "static/img/dragontiger_en.a253cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/dragontiger_en.png
// module id = 8eV3
// module chunks = 1